module.exports = __webpack_public_path__ + "static/media/enjoyCook2.ec4d7500.png";